import "../css/app.scss";
import "vue-final-modal/style.css";

import { createApp } from "vue";
import { createVueWait } from "vue-wait";
import { createVfm } from "vue-final-modal";
import { createWebHistory, createRouter } from "vue-router";

import { setupI18n } from "./i18n.js";

import App from "./App.vue";

import Button from "./components/Button.vue";
import HomeView from './views/Home.vue'
import FinishedView from './views/Finished.vue'

const vueWait = createVueWait();

const i18n = setupI18n();

const routes = [
    { path: "/", component: HomeView },
    { name: 'finished', path: "/finished", component: FinishedView },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const app = createApp(App);
app.component("v-button", Button);
app.use(createVfm());
app.use(vueWait);
app.use(i18n);
app.use(router)
app.mount("body");